export type CalculateVenueCo2 = {
  global: CalculateVenueGlobalCo2;
  structure: CalculateVenueStructureCo2;
  dates: CalculateVenueDatesCo2;
};

export type CalculateVenueGlobalCo2 = {
  score: number; // 155 teCO2
  scoreLetter: string; // A B C D E (computed from scoreKgeCO2ByParticipant)
  kgeCO2ByParticipant: number; // 155 t * 1000 / 15 000 (capacity)  = 10.3
};

export type CalculateVenueStructureCo2 = {
  score: number;
  sectors: {
    site: {
      score: number;
      categories: {
        scenography: { score: number };
        material: { score: number };
        building: { score: number };
        energy: { score: number };
        water: { score: number };
        waste: { score: number };
        equipment: { score: number };
      };
    };
    team: {
      score: number;
      categories: {
        transport: { score: number };
        catering: { score: number };
      };
    };
    public: {
      score: number;
      categories: {
        catering: { score: number };
        digital: { score: number };
      };
    };
  };
};

export type CalculateVenueDatesCo2 = {
  score: number;
  byMonth: {
    [monthKey: string]: {
      score: number;
      env?: {
        score: number;
        maxScore: number;
      };
      totalMen?: number;
      totalWomen?: number;
      totalOther?: number;
    };
  };
  byDate: {
    [dateId: number]: {
      score: number;
    };
  };
};

export const EMPTY_CALCULATE_VENUE_CO2: CalculateVenueCo2 = {
  global: {
    score: 0,
    kgeCO2ByParticipant: 0,
    scoreLetter: '-',
  },
  structure: {
    score: 0,
    sectors: {
      site: {
        score: 0,
        categories: {
          scenography: { score: 0 },
          material: { score: 0 },
          building: { score: 0 },
          energy: { score: 0 },
          water: { score: 0 },
          waste: { score: 0 },
          equipment: { score: 0 },
        },
      },
      team: {
        score: 0,
        categories: {
          transport: { score: 0 },
          catering: { score: 0 },
        },
      },
      public: {
        score: 0,
        categories: {
          catering: { score: 0 },
          digital: { score: 0 },
        },
      },
    },
  },
  dates: {
    score: 0,
    byMonth: {},
    byDate: {},
  },
};
